import React, { useState, useCallback, useEffect } from "react";
import {
  Card,
  Grid,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  AppBar,
  Tabs,
  Tab,
  IconButton,
} from "@mui/material";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import MDAvatar from "components/MDAvatar";
import { useNavigate, useSearchParams } from "react-router-dom";
import { getFollowing } from "services/apiService";
import { getFollowers } from "services/apiService";
import TabPanel from "components/TabPanel";
import dialogBgImage from "assets/images/dialogBgImage.png";
import { useMediaQuery } from "react-responsive";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { updateUser } from "services/apiService";
import SpinLoader from "components/SpinLoader";
import InfiniteScroll from "react-infinite-scroll-component";
import { useSelector } from "react-redux";

function ExploreAllDialog({ openStatus, onClose, showTab }) {
  let navigate = useNavigate();
  const { feed, feedCount, feedPageNumber, feedLoading } = useSelector(
    (state) => state.followersFollowingData
  );
  const [searchParams] = useSearchParams();
  const [tabValue, setTabValue] = useState(showTab);
  const [followingData, setFollowingData] = useState([]);
  const [followersData, setFollowersData] = useState([]);
  const [followingPageNumber, setFollowingPageNumber] = useState(1);
  const [followersPageNumber, setFollowersPageNumber] = useState(1);
  const [isFetchMoreFollowing, setIsFetchMoreFollowing] = useState(false);
  const [isFetchMoreFollowers, setIsFetchMoreFollowers] = useState(false);
  const [tempList, setTempList] = useState([]);
  const [loading, setLoading] = useState(true);
  const isDesktopOrLaptop = useMediaQuery({
    query: "(min-width: 1224px)",
  });
  const isBigScreen = useMediaQuery({ query: "(min-width: 1824px)" });
  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 1224px)" });

  useEffect(() => {
    fetchFollowingAndFollowers();
  }, []);

  const handleSetTabValue = (event, newValue) => setTabValue(newValue);

  const fetchFollowingAndFollowers = async () => {
    setLoading(true);
    const followingRes = await getFollowing(
      searchParams.get("username"),
      followingPageNumber
    );
    // console.log("followingRes", followingRes);
    setFollowingData(followingRes);
    if (followingRes.length > 1) {
      setIsFetchMoreFollowing(true);
    }
    setFollowingPageNumber((prev) => prev + 1);

    const followersRes = await getFollowers(
      searchParams.get("username"),
      followersPageNumber
    );
    // console.log("followersRes", followersRes);
    setFollowersData(followersRes);
    if (followersRes.length > 1) {
      setIsFetchMoreFollowers(true);
    }
    setFollowersPageNumber((prev) => prev + 1);
    setLoading(false);
  };

  const fetchMoreFollowing = async () => {
    const followingResNew = await getFollowing(
      searchParams.get("username"),
      followingPageNumber
    );
    if (followingResNew.length < 1) {
      setIsFetchMoreFollowing(false);
      return;
    }
    setIsFetchMoreFollowing(true);
    setFollowingData(followingData.concat(followingResNew));
    setFollowingPageNumber((prev) => prev + 1);
  };

  const fetchMoreFollowers = async () => {
    const followersResNew = await getFollowers(
      searchParams.get("username"),
      followersPageNumber
    );
    if (followersResNew.length < 1) {
      setIsFetchMoreFollowers(false);
      return;
    }
    setIsFetchMoreFollowers(true);
    setFollowersData(followersData.concat(followersResNew));
    setFollowersPageNumber((prev) => prev + 1);
  };

  const handleFollowUnfollow = async (status, username) => {
    // console.log("usenrmae", username);
    if (status === "unfollow") {
      const updateData = {
        removeUser: username,
      };
      const updateUserRes = await updateUser(updateData);
      // console.log("updateUserRes1", updateUserRes);

      setTempList([...tempList, username]);
      const followersRes = await getFollowers(searchParams.get("username"), 1);
      // console.log("followersRes", followersRes);
      setFollowersData(followersRes);
      // setStatusUpdateBoolean((prev) => !prev);
    } else {
      const updateData = {
        followers: username,
      };
      const updateUserRes = await updateUser(updateData);
      // console.log("updateUserRes2", updateUserRes);
      setTempList(tempList.filter((name) => name !== username));
      // setStatusUpdateBoolean((prev) => !prev);
    }
  };

  // console.log("tempList", tempList);

  const handleNavigate = (value) => {
    navigate(`/profile/?username=${value}`);
  };

  return (
    <Dialog
      sx={{}}
      open={openStatus}
      maxWidth="sm"
      fullWidth
      fullScreen={isTabletOrMobile && true}
      onClose={onClose}
    >
      <MDBox
        id="scrollableBox"
        sx={{
          overflow: "auto",
          height: "100%",
          border: isDesktopOrLaptop && "1px solid #F2CB2E",
          borderRadius: isDesktopOrLaptop && "8px",
          backgroundColor: "#1a1a1a",
          // backgroundImage: `url(${dialogBgImage})`,
          // backgroundRepeat: "no-repeat",
          // backgroundSize: "cover",
          // objectFit: "cover",
          // backgroundPosition: isTabletOrMobile && "bottom",
        }}
      >
        <DialogTitle sx={{ textAlign: "center", padding: "10px" }}>
          <MDBox sx={{ display: "flex", justifyContent: "space-between" }}>
            {isTabletOrMobile && (
              <IconButton
              // onClick={() => handleBack()}
              >
                <IconButton onClick={onClose} color="white" fontSize="30px">
                  <ArrowBackIcon />
                </IconButton>
              </IconButton>
            )}
          </MDBox>

          <AppBar position="static" sx={{}}>
            <Tabs
              sx={{ backgroundColor: "#00000000" }}
              // orientation={tabsOrientation}
              value={tabValue}
              onChange={handleSetTabValue}
            >
              <Tab sx={{ backgroundColor: "transparent" }} label="Following" />
              <Tab label="Followers" />
            </Tabs>
          </AppBar>
        </DialogTitle>
        <DialogContent>
          <MDBox>
            <TabPanel value={tabValue} index={0}>
              <InfiniteScroll
                scrollableTarget="scrollableBox"
                dataLength={followingData.length}
                next={fetchMoreFollowing}
                hasMore={isFetchMoreFollowing}
                loader={
                  null
                  // <MDBox sx={{ textAlign: "center" }}>
                  //   <SpinLoader />
                  // </MDBox>
                }
              >
                {loading ? (
                  <MDBox sx={{ marginTop: "3rem", textAlign: "center" }}>
                    <SpinLoader />
                  </MDBox>
                ) : followingData.length > 0 ? (
                  followingData.map((item, idx) => (
                    <MDBox
                      key={idx}
                      style={{
                        marginBottom: "20px",
                        display: "flex",
                        // gap: "10px",
                        alignItems: "center",
                        justifyContent: "space-between",
                      }}
                    >
                      <MDBox
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          gap: "10px",
                        }}
                        onClick={() => handleNavigate(item.username)}
                      >
                        <MDAvatar
                          src={item.pic}
                          imgProps={{
                            style: { height: "100%", width: "100%" },
                          }}
                        />
                        <MDBox>
                          <MDTypography fontWeight="bold">
                            {item.fullName}
                          </MDTypography>
                          <MDTypography fontSize="15px">
                            {item.username}
                          </MDTypography>
                        </MDBox>
                      </MDBox>

                      {localStorage.userNameSingh ===
                        searchParams.get("username") && (
                        <MDBox>
                          {tempList.includes(item.username) ? (
                            <MDButton
                              color="singh"
                              onClick={() =>
                                handleFollowUnfollow("follow", item.username)
                              }
                            >
                              Follow
                            </MDButton>
                          ) : (
                            <MDButton
                              color="singh"
                              onClick={() =>
                                handleFollowUnfollow("unfollow", item.username)
                              }
                            >
                              Unfollow
                            </MDButton>
                          )}
                        </MDBox>
                      )}
                    </MDBox>
                  ))
                ) : (
                  <MDBox sx={{ textAlign: "center", marginTop: "3rem" }}>
                    <MDTypography color="text">
                      You have not followed anyone yet
                    </MDTypography>
                  </MDBox>
                )}
              </InfiniteScroll>
            </TabPanel>
            <TabPanel value={tabValue} index={1}>
              <InfiniteScroll
                scrollableTarget="scrollableBox"
                dataLength={followersData.length}
                next={fetchMoreFollowers}
                hasMore={isFetchMoreFollowers}
                loader={
                  null
                  // <MDBox sx={{ textAlign: "center" }}>
                  //   <SpinLoader />
                  // </MDBox>
                }
              >
                {loading ? (
                  <MDBox sx={{ marginTop: "3rem", textAlign: "center" }}>
                    <SpinLoader />
                  </MDBox>
                ) : followersData.length > 0 ? (
                  followersData.map((item, idx) => (
                    <MDBox
                      key={idx}
                      style={{
                        marginBottom: "20px",
                        display: "flex",
                        // gap: "10px",
                        alignItems: "center",
                        justifyContent: "space-between",
                      }}
                    >
                      <MDBox
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          gap: "10px",
                        }}
                        onClick={() => handleNavigate(item.username)}
                      >
                        <MDAvatar
                          src={item.pic}
                          imgProps={{
                            style: { height: "100%", width: "100%" },
                          }}
                        />
                        <MDBox>
                          <MDTypography fontWeight="bold">
                            {item.fullName}
                          </MDTypography>
                          <MDTypography fontSize="15px">
                            {item.username}
                          </MDTypography>
                        </MDBox>
                      </MDBox>

                      {localStorage.userNameSingh ===
                        searchParams.get("username") && (
                        <MDBox>
                          <MDButton
                            onClick={() =>
                              handleFollowUnfollow("unfollow", item.username)
                            }
                            color="singh"
                          >
                            Remove
                          </MDButton>
                        </MDBox>
                      )}
                    </MDBox>
                  ))
                ) : (
                  <MDBox sx={{ textAlign: "center", marginTop: "3rem" }}>
                    <MDTypography color="text">
                      You have no followers yet
                    </MDTypography>
                  </MDBox>
                )}
              </InfiniteScroll>
            </TabPanel>
          </MDBox>
        </DialogContent>
        {/* <DialogActions></DialogActions> */}
      </MDBox>
    </Dialog>
  );
}

export default ExploreAllDialog;
